import { EmptyState } from '@repo/ui';

export function MatterLedgerHistoryView() {
  return (
    <EmptyState
      icon="HiClock"
      title="Upcoming"
      description="Report history feature is coming soon. You will be able to view and manage previously generated reports here."
      variant="outlined"
      padding="lg"
    />
  );
}

